export default __webpack_public_path__ + "static/media/ArmButtonInActive.e565c04c.svg";